import * as React from 'react'

import { useTFLSearchResult, UseTFLSidebarSearchReturn } from '../../hooks'
import type { DocumentGroup } from '../../utils/searchResultGrouping'

import { SearchResultItem } from './SearchResultItem'

interface TFLSearchResultProps extends Partial<UseTFLSidebarSearchReturn> {}

const TFLSearchResult: React.FC<TFLSearchResultProps> = ({
  results,
  loadMoreRef,
  isLoading,
  hasNextPage,
}) => {
  const { groupedResults } = useTFLSearchResult(results)

  if (isLoading) return null

  if (!groupedResults?.length) {
    return (
      <div className="flex items-center justify-center p-8 text-gray-500">
        <p className="text-xs">No results found</p>
      </div>
    )
  }

  return (
    <div className="px-2">
      {/* Search Results List */}
      {groupedResults.map((documentGroup: DocumentGroup, index) => {
        return (
          <SearchResultItem
            key={documentGroup.documentId}
            documentGroup={documentGroup}
            groupIndex={index}
          />
        )
      })}

      {/* Load More Trigger */}
      {hasNextPage && <div ref={loadMoreRef} className="w-full h-5" />}
    </div>
  )
}

const TFLSearchResultMemorized = React.memo(TFLSearchResult)

export { TFLSearchResultMemorized as TFLSearchResult }
